import MatchEmpty from '../../Common/MatchEmpty.vue'
import fixSafariOverflowScrolling from '../../../utils/safari-fix'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import { Card, CardItem } from '../../Common/Card'
import LoadingView from '../../Common/LoadingView.vue'
import TravelOrderCard from './TravelOrderCard.vue'
import { mapState, mapActions } from 'vuex'

export default {
name: 'travel-order-list',
components: {
XHeader,
Tab,
TabItem,
Card,
CardItem,
LoadingView,
TravelOrderCard,
MatchEmpty,
},
data() {
return {
showLoading: false,
offset: 0,
limit: 99,
}
},
computed: {
...mapState({
orders: ({ travelOrder }) => travelOrder.travelOrderListData.orders,
}),
},
mounted() {
this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling')
fixSafariOverflowScrolling(this, 'touch')
},
methods: {
...mapActions(['showToast', 'fetchTravelOrderList']),
},
created() {
const params = {
userId: this.$jwt.userId,
offset: this.offset,
limit: this.limit,
}
this.fetchTravelOrderList(params)
},
}



// WEBPACK FOOTER //
// ./client/components/SportsTour/Order/TravelOrderList.vue